// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { generateId } from '../../_common/api/utility';
import Button from '../../_common/form/Button';
import Form from '../../_common/form/Form';
import Input from '../../_common/form/Input';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import LocationList from '../../_common/LocationList';
import Modal from '../../_common/Modal';
import Card from '../Card';
import { HamQuest } from '../../../App';


const Terms = styled.div`
    font-size: 0.6em;
    margin: 0.6em 0;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.2em;
`
const PromoCodes = ({ ...props }) => {
    const {
        state: {
            active_user,
            site_config
        },
        updateEmailConfirmation
    } = useGlobalState();

    const [deals, setDeals] = useState([]);
    const [shownDeals, setShownDeals] = useState([]);

    const getDeals = () => {
        HamQuest.get(QuestRoute.products.deals)
            .then((res) => setDeals(res.filter(e => e.numberClaimed < e.claimLimit)))
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Deals',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }

    useEffect(() => {
        if (!active_user.account.emailConfirmed) {
            HamQuest.get(QuestRoute.user.confirmedEmail)
                .then(confirmed => {
                    if (confirmed) {
                        updateEmailConfirmation(true);
                        getDeals();
                    }
                })
        } else {
            getDeals();
        }
    }, [])

    useEffect(() => {
        if (deals.length !== shownDeals.length) {
            setShownDeals(
                deals.map(e => {
                    return (
                        <Card key={generateId()}>
                            <Title>{e.name}</Title>
                            <span>{e.description}</span>
                            <LocationList itemLocations={e.locations} />
                            <Button onClick={() => claimDeal(e)}>Claim Deal</Button>
                            <Terms>{e.terms}</Terms>
                        </Card>
                    )
                })
            )
        }
    }, [deals])

    const claimDeal = (deal) => {
        Modal.Promise({
            title: 'Claiming Deal',
            body: <Loading />,
            callback: HamQuest.post(QuestRoute.user.deals, {
                dealId: deal.dealId
            })
        })
            .then(() => {
                getDeals();
                Modal.Show({
                    title: 'Deal Added to your Wallet!',
                    body: 'Head to your wallet to view and use your code.',
                    type: 'success'
                })
            })
    }

    return !active_user.account.emailConfirmed ? (
        <Card title='Please Confirm your Email' icon='barcode' />
    ) : (
        <>
            <Card title='Have a PROMO Code?' icon='barcode'>
                <Form
                    inputs={{
                        code: ''
                    }}
                    onSubmit={(e) =>
                        HamQuest.post(QuestRoute.products.promoCode, {
                            code: e.code
                        })
                            .then(res => {
                                Modal.Show({
                                    title: 'Code Claimed',
                                    body: <div>{res.name}<br />Added to your Wallet!</div>,
                                    type: 'success'
                                })
                            })
                    }
                >
                    <Input
                        name='code'
                        label='Enter your Code Here'
                        maxLength={20}
                    />
                </Form>
            </Card>
            {shownDeals}
        </>
    );
}

export default PromoCodes;